import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

const CollegeCard = ({slug, name}) => (
  <div className="college-discovery-step-college-card-logo">
    <img src={`//colleges-static.raise.me/${slug}/logo-120x120.png`} alt={`${name} logo`} />
  </div>
);

CollegeCard.propTypes = propTypes;

export default CollegeCard;
